import ShDividerLine from '@/components/Helpers/ShDividerLine';

// @vue/component
export default {
  name: 'ShModalWindow',
  components: {
    ShDividerLine,
  },
  props: {
    width: {
      type: String,
      default: 'circle-thin',
    },
    height: {
      type: String,
      default: 'Page header title',
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
    };
  },

  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },

  methods: {
    handleClickOutside(event) {
      if (event.target instanceof HTMLElement && event.target.parentElement.id !== 'modal') {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
